import { useCallback, useRef } from 'react';

export const usePhoneValidate = () => {
  const phoneRef = useRef<{ setEdited: (edited: boolean) => void } | null>(
    null
  );

  const validatePhone = useCallback(() => {
    phoneRef.current?.setEdited(true);
  }, []);

  return {
    phoneRef,
    validatePhone,
  };
};
